import React, { useEffect, useState } from 'react';
import { Divider, Box, Stepper, Step, StepLabel } from '@mui/material';
import SignUpComplete from 'components/SignUp/SignUpComplete';
import SignUpAgreeTerms from 'components/SignUp/SignUpAgreeTerms';
import SignUpEnterInform from 'components/SignUp/SignUpEnterInform';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { useTranslation } from 'react-i18next';

const steps = ['sign_up_steps.agree_terms', 'sign_up_steps.enter_inform', 'sign_up_steps.complete'];
export default function SignUp() {
  const [activeStep, setActiveStep] = useState(0);
  // 다국어
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'ko');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleStorageChange = () => {
      setLanguage(localStorage.getItem('language') || 'ko');
    };
    window.addEventListener('storage', handleStorageChange);

    i18n.changeLanguage(language);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const AgreeTerms = 0;
  const EnterInform = 1;
  const CompleteSignUp = 2;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1
      }}
    >
      {/* Header를 클릭하면 메인페이지로 이동 */}
      <Header />
      {/* 경계선 */}
      <Divider />
      <main
        style={{
          flex: '1', // 남은 공간을 차지하도록 설정
          width: '100%',
          maxWidth: '1600px',
          margin: '16px auto'
        }}
      >
        <h1 style={{ textAlign: 'center', fontSize: '32px', fontWeight: 'bold', height: '100px', alignContent: 'center' }}> {t('sign_up')}</h1>
        <Box width="100%" px="20px">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{t(label)}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === CompleteSignUp ? (
            // 회원가입 완료 페이지
            <SignUpComplete />
          ) : activeStep === AgreeTerms ? (
            // 동의 약관 페이지
            <SignUpAgreeTerms handleNext={handleNext} handleBack={handleBack} />
          ) : (
            // 회원정보 입력 페이지
            <SignUpEnterInform handleNext={handleNext} handleBack={handleBack} />
          )}
        </Box>
      </main>
      {/* 경계선 */}
      <Divider />
      {/* 푸터 */}
      <Footer maxWidth={1920} />
    </div>
  );
}
